module.exports = __webpack_public_path__ + "static/media/Pattern6.6c1a4d84.jpg";